import {Component, OnInit} from '@angular/core';
import {Help} from '../help';
import {ActivatedRoute, Router} from '@angular/router';
import {HelpService} from '../help.service';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ViewComponent implements OnInit {

  help: Help = new Help();

  constructor(private router: Router,
              private route: ActivatedRoute,
              private helpService: HelpService) {
  }

  ngOnInit() {
    const id = this.route.params.subscribe(params => {
      const codigo = params['codigo'];

      if (!codigo) {
        return;
      }

      this.helpService.getHelp(codigo)
        .subscribe(
          help => this.help = help,
          response => {
            if (response.status === 404) {
              this.router.navigate(['NotFound']);
            }
          });
    });
  }

  getCaminho(caminho: string) {
    if (!caminho) {
      return '';
    }

    return caminho.split(';');
  }

  getCaminho2(caminho: string) {
    if (!caminho) {
      return '';
    }

    return caminho.split('/');
  }

}



// WEBPACK FOOTER //
// ./src/app/help/view/view.component.ts